import React from 'react';
import PropTypes from 'prop-types';
import Tab from '../Tab';
import ManualPDF from './ManualPDF';
import Tabs from '../Tabs';
import './ManualTab.scss';
import { SafeSVG } from '../svg/SafeSVG';


/**
 * Custom Manual
 * @module
 * @param {bool} isOpenManualTab - Is Custom manual tab dialog open?
 * @param {func} handleClose - Handle close function
 * @param {string} manualTitle - Manual Title
 * @param {manualProps} manualProps - Props for manual
 * @param {func} getManual - Function to get manual
 */

class ManualTab extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpenManualDialogPDF: false,
      manualTab: '',
      titlePDF: '',
    };
  }

  handleOpenPDF = async (ID, N_TITLE) => {
    await this.props.getManual(ID);
    this.setState({
      isOpenManualDialogPDF: true,
      titlePDF: N_TITLE,
    });
  };

  handleCloseList = () => {
    this.props.handleClose();
  };

  handleClosePDF = () => {
    this.setState({
      isOpenManualDialogPDF: false,
    });
  };

  render() {
    const buildCustomManual = () => {
      const { manualProps } = this.props;
      const { manualTabListData, manualTabList } = manualProps;

      return (
        <div className="custom-manual">
          <Tabs>
            {
              manualTabList.map((item, index) => {
                return (
                  <Tab eventKey={item.manualTabType} title={item.tabTitle} className="manual" key={index}>
                    {/* nutne vyriesit to ze ak sa dana skupina priruciek v module nenachadza ako vytvorit podmienku */}
                    <div className="content">


                      <div className="row">
                        <div className="col title-content">
                          {/* nutne vyriesit to ze ak sa dana skupina priruciek v module nenachadza ako vytvorit podmienku */}
                          {/* {manualTabListData.C_TYP_SKR === "P" && manualTabListData.map((x)  => {
                            if(item.manualTabType === x.N_TAB && x.C_TYP_SKR === "P")
                            return(
                              <div>

                              </div>
                            )
                          } */}

                          <span className="title">Príručka</span>
                          {/* <p>{x.POZN ? x.POZN : ''}</p> */}
                        </div>
                        <div className="PDF-data">
                          {manualTabListData.map((x) => {
                            if (item.manualTabType === x.N_TAB && x.C_TYP_SKR === "P") {
                              return (
                                <div className="row" key={x.I_SP_DOKUM}>
                                  <div className="col">
                                    <div className="pdf-name">
                                      <div className="name" onClick={() => this.handleOpenPDF(x.I_SP_DOKUM, x.N_TITLE)}>
                                        <SafeSVG className="img-pdf" src="assets/icons/toolbar/pdf.svg" alt="pdf" />
                                        <span className="pdf-title">{x.N_TITLE} {x.N_CISLO ? x.N_CISLO : ''}</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col">
                                    <div>
                                      <span className="datum">{x.DAT_UPR ? x.DAT_UPR : ''}</span>
                                    </div>
                                  </div>
                                </div>
                              );
                            } else return null;
                          })}
                        </div>
                      </div>

                      <div className="row">
                        <div className="col title-content">
                          <span className="title">Zmenové dokumenty</span>
                          {/* <p>{x.POZN ? x.POZN : ''}</p> */}
                        </div>
                        <div className="PDF-data">
                          {manualTabListData.map((x) => {
                            if (item.manualTabType === x.N_TAB && x.C_TYP_SKR === "ZD") {
                              return (
                                <div className="row" key={x.I_SP_DOKUM}>
                                  <div className="col">
                                    <div className="pdf-name">
                                      <div className="name" onClick={() => this.handleOpenPDF(x.I_SP_DOKUM, x.N_TITLE)}>
                                        <SafeSVG className="img-pdf" src="assets/icons/toolbar/pdf.svg" alt="pdf" />
                                        <span className="pdf-title">{x.N_TITLE} {x.N_CISLO ? x.N_CISLO : ''}</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col">
                                    <div>
                                      <span className="datum">{x.DAT_UPR ? x.DAT_UPR : ''}</span>
                                    </div>
                                  </div>
                                </div>
                              );
                            } else return null;
                          })}
                        </div>
                      </div>

                      <div className="row">
                        <div className="col title-content">
                          <span className="title">Metodické postupy</span>
                          {/* <p>{x.POZN ? x.POZN : ''}</p> */}
                        </div>
                        <div className="PDF-data">
                          {manualTabListData.map((x) => {
                            if (item.manualTabType === x.N_TAB && x.C_TYP_SKR === "M") {
                              return (
                                <div className="row" key={x.I_SP_DOKUM}>
                                  <div className="col">
                                    <div className="pdf-name" >
                                      <div className="name" onClick={() => this.handleOpenPDF(x.I_SP_DOKUM, x.N_TITLE)}>
                                        <SafeSVG className="img-pdf" src="assets/icons/toolbar/pdf.svg" alt="pdf" />
                                        <span className="pdf-title">{x.N_TITLE} {x.N_CISLO ? x.N_CISLO : ''}</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col">
                                    <div>
                                      <span className="datum">{x.DAT_UPR ? x.DAT_UPR : ''}</span>
                                    </div>
                                  </div>
                                </div>
                              );
                            } else return null;
                          })}
                        </div>
                      </div>

                      <div className="row">
                        <div className="title-content">
                          <span className="title">Zákony a vyhlášky</span>
                          {/* <p>{x.POZN ? x.POZN : ''}</p> */}
                        </div>
                        <div className="PDF-data">
                          {manualTabListData.map((x) => {
                            if (item.manualTabType === x.N_TAB && x.C_TYP_SKR === "Z") {
                              return (
                                <div className="row" key={x.I_SP_DOKUM}>
                                  <div className="col">
                                    <div className="pdf-name">
                                      <div className="name" onClick={() => this.handleOpenPDF(x.I_SP_DOKUM, x.N_TITLE)}>
                                        <SafeSVG className="img-pdf" src="assets/icons/toolbar/pdf.svg" alt="pdf" />
                                        <span className="pdf-title">{x.N_TITLE} {x.N_CISLO ? x.N_CISLO : ''}</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col">
                                    <div>
                                      <span className="datum">{x.DAT_UPR ? x.DAT_UPR : ''}</span>
                                    </div>
                                  </div>
                                </div>
                              );
                            } else return null;
                          })}
                        </div>
                      </div>
                    </div>
                  </Tab>
                );
              })
            }
          </Tabs>
        </div >
      );
    };
    return (
      <>
        {buildCustomManual()}
        < ManualPDF
          extraDialog={true}
          manualProps={this.props.manualProps}
          handleClosePDF={this.handleClosePDF}
          isOpenManualDialogPDF={this.state.isOpenManualDialogPDF}
          getManual={this.props.getManual}
          manualTitle={this.props.manualTitle}
          getTabManualList={this.props.getTabManualList}
          titlePDF={this.state.titlePDF}
        />
      </>
    );
  }
}

ManualTab.propTypes = {
  getManual: PropTypes.func.isRequired,
  manualProps: PropTypes.shape({
    hasList: PropTypes.bool.isRequired,
    hasCustom: PropTypes.bool,
    listManual: PropTypes.object,
    listTabManual: PropTypes.object,
    manualTablist: PropTypes.object,
    user: PropTypes.object,
    manualBlob: PropTypes.object,
    manualFileName: PropTypes.string,
    manualTitle: PropTypes.string,
    manualTabList: PropTypes.arrayOf(PropTypes.object),
    manualTabListData: PropTypes.array,
    manualTabListDataMap: PropTypes.object
  }).isRequired,
  isOpenManualTab: PropTypes.bool,
  handleClose: PropTypes.func,
  manualTitle: PropTypes.string,
};


export default ManualTab;